// extracted by mini-css-extract-plugin
export var experienciasContainer = "ExperienciaMusical-module--experienciasContainer--ewD+k";